import React from 'react'
import { TouchableWithoutFeedback, Keyboard } from 'react-native'

type Props = {
  children: React.ReactElement
}

export const DismissKeyboard: React.FC<Props> = ({ children }: Props) => (
  <TouchableWithoutFeedback onPress={() => Keyboard.dismiss()}>
    {children}
  </TouchableWithoutFeedback>
)

export default DismissKeyboard